import type { VerticalCopy } from "@/lib/verticalCopy";

/**
 * The applicant's consent sentence on the first screen, for every look. The
 * decision it disclaims comes from the copy deck (`decisionKind`), never from
 * a per-partner string. Split around the org name so a screen can set the
 * name in bold. Keep the wording here, in one place.
 */
export function applicantConsentSentence(
  orgName: string,
  copy: Pick<VerticalCopy, "decisionKind">,
): { beforeOrg: string; org: string; afterOrg: string } {
  return {
    beforeOrg: "I agree to share the identity details I choose to provide with",
    org: orgName,
    afterOrg: `for this application. DigaVouch does not make the ${copy.decisionKind} decision.`,
  };
}
